import useAboutContent from "src/hooks/use-about-content";
import useReveal from "src/hooks/use-reveal";

// КОМПАНИЯ В ЦИФРАХ — ПОЛОСА МЕЖДУ ПЕРВЫМ ЭКРАНОМ И ТУРАМИ.
//
// Место выбрано не для красоты. Человек только что прочитал заголовок и
// нажал бы «посмотреть туры», но перед ценой в 2600 $ ему нужен ответ на
// вопрос «а вы вообще кто». Четыре числа — 21 префектура, 97% одобрения виз,
// 200+ путешественников, 5+ лет в стране — отвечают на него за секунду и
// стоят ровно на переходе: сразу под первым экраном и прямо над строкой
// «Ближайшие туры» с кнопкой «Посмотреть все туры».
//
// Раньше эти же цифры висели внизу первого экрана и только при заполненной
// админке: пустая настройка `about` — и на главной не было ни одной цифры.
// Теперь содержимое берётся из админки, а запасное — из переводов
// (см. src/hooks/use-about-content.js), поэтому полоса есть всегда.
export default function StatsBand() {
  const { stats, statsTitle } = useAboutContent();
  const reveal = useReveal();

  if (!stats.length) return null;

  return (
    <section
      ref={reveal.ref}
      aria-label={statsTitle}
      className={`w-full max-w-[1526px] mx-auto px-4 ${reveal.className}`}
    >
      <div className="relative overflow-hidden rounded-2xl border border-kj-line bg-kj-card/50 px-5 py-6 sm:px-8 sm:py-7">
        {/* Тёплая подсветка вдоль верхнего края — полоса не должна читаться
            как ещё одна тёмная плита между двумя фотографиями. */}
        <span
          aria-hidden="true"
          className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-kj-gold/60 to-transparent"
        />
        <p className="text-[11px] sm:text-xs font-extrabold uppercase tracking-[0.28em] text-kj-gold">
          {statsTitle}
        </p>
        {/* На телефоне две колонки: четыре числа в столбик занимали бы весь
            экран и превращали переход в отдельную страницу статистики. */}
        <dl className="mt-5 grid grid-cols-2 gap-x-6 gap-y-6 lg:grid-cols-4 lg:gap-x-10">
          {stats.map((stat, i) => (
            <div key={i} className="max-w-[26ch]">
              <dt className="sr-only">{stat.label.value}</dt>
              <dd>
                <span className="block text-3xl sm:text-4xl font-extrabold text-kj-gold tabular-nums leading-none">
                  {stat.value}
                </span>
                <span
                  {...stat.label.attrs}
                  className="mt-2 block text-xs sm:text-sm uppercase tracking-[0.1em] text-kj-sub leading-snug"
                >
                  {stat.label.value}
                </span>
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
